/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Image_ChooseInputs */

const vi_shop_image_choose = /** @type {(inputs: Shop_Image_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn ảnh`)
};

/**

* @param {Shop_Image_ChooseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_image_choose = /** @type {((inputs?: Shop_Image_ChooseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Image_ChooseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_image_choose(inputs)
});